import { GetServerSideProps } from "next";
import Head from "next/head";
import request from '@/utils/request';

const getServerSideProps: GetServerSideProps = async context => {
  const { data } = await request.get(`/getHomeMenuDetail`, {
    params: {
      path: context?.resolvedUrl?.split('?')[0],
    },
    headers: {
      lang: context?.locale || 'cn'
    }
  });

  return {
    props: {
      navDetail: data.data || null,
      menuDetail: data.data || null,
    },
  };
};

const getHead = (menuDetail: any) => {
  return (
    <Head>
      {
        menuDetail?.meta_title && <title>{menuDetail?.meta_title} </title>
      }
      {
        menuDetail?.meta_kws && <meta name="keywords" content={menuDetail?.meta_kws} />
      }
      {
        menuDetail?.meta_desc && <meta name="description" content={menuDetail?.meta_desc} />
      }
    </Head>
  )
}
export { getHead, getServerSideProps }
